import React, { useReducer, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Header from '../../../components/Header/index'
import LoadingAbsolute from '../../../components/Loading/LoadingAbsolute'
import InfoRedCard from './InfoRedCard'
import { Button } from 'reactstrap'
import CheckBoxErrorText from './CheckBoxErrorText'
import Modal from '../../../components/MyModal/MyModal'
import GuestRulesModalBody from './GuestRulesModalBody'
import SuccessModalBody from './SuccessModalBody'
import '../HobiBahcesiGirisSistemi.css'
import { isValidDate } from '../../../helpers/index'
import GuestTypeSelector from './GuestTypeSelector'
import GuestInfoForm from './GuestInfoForm'
import { setUser } from '../../../store/userReducer'
import { persistSelectedGarden, resolveSelectedGarden } from '../services/selectedGardenStorage'

// State ve error'ları gruplayan reducer
const initialState = {
  adi: '',
  adiError: false,
  soyadi: '',
  soyadiError: false,
  tc: '',
  tcError: false,
  dogumTarihi: '',
  dogumTarihiError: false,
  tel: '',
  telError: false,
  misafirTuru: 'gecici',
  girisTipiError: false,
  plaka: '',
  plakaAvailable: false,
  selectedCount: null,
  formData: [],
  isFading: false,
  loading: true,
  openGuestRulesModal: false,
  openSuccessModal: false,
  selectedTesis: null,
}

function reducer(state, action) {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value }
    case 'SET_ERROR':
      return { ...state, [action.field]: action.value }
    case 'SET_FORMDATA':
      return { ...state, formData: action.value }
    case 'SET_LOADING':
      return { ...state, loading: action.value }
    case 'SET_MODAL':
      return { ...state, [action.field]: action.value }
    case 'SET_SELECTED_TESIS':
      return { ...state, selectedTesis: action.value }
    case 'SET_IS_FADING':
      return { ...state, isFading: action.value }
    default:
      return state
  }
}

const GuestAddFormPage = () => {
  let location = useLocation()
  const navigate = useNavigate()
  const reduxDispatch = useDispatch()
  const data = resolveSelectedGarden(location?.state?.selectedTesis)

  const today = new Date()
  const todayString = today.toLocaleString('tr-TR', { timeZone: 'UTC' }).slice(0, 10)
  const kapanisSaati = data?.kapanis_saati?.slice(0, 5) ?? '-'

  // useReducer ile state yönetimi
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    loading: !data,
    selectedTesis: data,
  })

  useEffect(() => {
    if (data) {
      dispatch({ type: 'SET_LOADING', value: false })
      dispatch({ type: 'SET_SELECTED_TESIS', value: data })
      persistSelectedGarden(data)
      reduxDispatch(setUser(data))
    }
  }, [data, reduxDispatch]) // eslint-disable-line

  // TC kimlik numarası error kontrolü için useEffect
  useEffect(() => {
    if (state.tc.length === 0) {
      dispatch({ type: 'SET_ERROR', field: 'tcError', value: false })
    } else if (state.tc.length === 11) {
      dispatch({ type: 'SET_ERROR', field: 'tcError', value: false })
    } else {
      dispatch({ type: 'SET_ERROR', field: 'tcError', value: true })
    }
  }, [state.tc])

  const successToggle = () => {
    dispatch({ type: 'SET_MODAL', field: 'openSuccessModal', value: !state.openSuccessModal })
  }

  const countGuetRulesToggle = () => {
    dispatch({ type: 'SET_MODAL', field: 'openGuestRulesModal', value: !state.openGuestRulesModal })
  }

  const formatName = (input) => {
    if (!input) return ''

    return input
      .split(' ')
      .map((word) => {
        if (word.length === 0) return ''
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      })
      .join(' ')
  }

  // Generic input değişim handler'ı
  const handleInputChange = (e) => {
    const { name, value } = e.target
    let formattedValue = value
    if (name === 'adi' || name === 'soyadi') {
      formattedValue = formatName(value)
    }
    dispatch({ type: 'SET_FIELD', field: name, value: formattedValue })

    // Error kontrolü (temel uzunluk ve format)
    switch (name) {
      case 'adi':
        if (formattedValue.length >= 2) {
          dispatch({ type: 'SET_ERROR', field: 'adiError', value: false })
        } else if (formattedValue.length > 0) {
          dispatch({ type: 'SET_ERROR', field: 'adiError', value: true })
        } else {
          dispatch({ type: 'SET_ERROR', field: 'adiError', value: false })
        }
        break
      case 'soyadi':
        if (formattedValue.length >= 2) {
          dispatch({ type: 'SET_ERROR', field: 'soyadiError', value: false })
        } else if (formattedValue.length > 0) {
          dispatch({ type: 'SET_ERROR', field: 'soyadiError', value: true })
        } else {
          dispatch({ type: 'SET_ERROR', field: 'soyadiError', value: false })
        }
        break
      case 'tc':
        if (value.length === 0) {
          dispatch({ type: 'SET_ERROR', field: 'tcError', value: false })
        } else if (value.length === 11) {
          dispatch({ type: 'SET_ERROR', field: 'tcError', value: false })
        } else {
          dispatch({ type: 'SET_ERROR', field: 'tcError', value: true })
        }
        break
      case 'dogumTarihi':
        if (isValidDate(value)) {
          dispatch({ type: 'SET_ERROR', field: 'dogumTarihiError', value: false })
        } else if (value.length > 0) {
          dispatch({ type: 'SET_ERROR', field: 'dogumTarihiError', value: true })
        } else {
          dispatch({ type: 'SET_ERROR', field: 'dogumTarihiError', value: false })
        }
        break
      case 'tel': {
        const cleanValue = value.replace(/[^0-9]/g, '')
        if (cleanValue.length === 0) {
          dispatch({ type: 'SET_ERROR', field: 'telError', value: false })
        } else if (cleanValue.length === 10) {
          dispatch({ type: 'SET_ERROR', field: 'telError', value: false })
        } else {
          dispatch({ type: 'SET_ERROR', field: 'telError', value: true })
        }
        break
      }
      default:
        break
    }
  }

  const handleRadioOnCheck = (e) => {
    if (e.target.value !== state.misafirTuru) {
      dispatch({ type: 'SET_FIELD', field: 'misafirTuru', value: e.target.value })
      dispatch({ type: 'SET_IS_FADING', value: true })
      setTimeout(() => {
        dispatch({ type: 'SET_IS_FADING', value: false })
      }, 200)
    }
  }

  const formValidCheck = () => {
    // const isValid = state.adi?.length => 2 && state.soyadi?.length => 2 && state.tc?.length === 11 && isValidDate(state.dogumTarihi) && state.tel?.length >= 15
    const isValid = state.tc?.length === 11 && isValidDate(state.dogumTarihi) && state.tel?.length >= 15

    if (state.adi?.length < 2) {
      dispatch({ type: 'SET_ERROR', field: 'adiError', value: true })
    } else {
      dispatch({ type: 'SET_ERROR', field: 'adiError', value: false })
    }

    if (state.soyadi?.length < 2) {
      dispatch({ type: 'SET_ERROR', field: 'soyadiError', value: true })
    } else {
      dispatch({ type: 'SET_ERROR', field: 'soyadiError', value: false })
    }

    if (state.tc?.length === 11) {
      dispatch({ type: 'SET_ERROR', field: 'tcError', value: false })
    } else {
      dispatch({ type: 'SET_ERROR', field: 'tcError', value: true })
    }

    if (isValidDate(state.dogumTarihi)) {
      dispatch({ type: 'SET_ERROR', field: 'dogumTarihiError', value: false })
    } else {
      dispatch({ type: 'SET_ERROR', field: 'dogumTarihiError', value: true })
    }

    if (state.tel?.length < 15) {
      dispatch({ type: 'SET_ERROR', field: 'telError', value: true })
    } else {
      dispatch({ type: 'SET_ERROR', field: 'telError', value: false })
    }

    if (state.misafirTuru?.length < 1) {
      dispatch({ type: 'SET_GIRIS_TIPI_ERROR', value: true })
    } else {
      dispatch({ type: 'SET_GIRIS_TIPI_ERROR', value: false })
    }

    if (isValid) {
      dispatch({
        type: 'SET_FORMDATA',
        value: {
          name: state.adi,
          surname: state.soyadi,
          phone: state.tel,
          misafirTuru: state.misafirTuru,
          identification_number: state.tc,
          input_type: state.misafirTuru,
          number_plate: state.plaka,
          guest_count: state.selectedCount,
          birth_date: state.dogumTarihi,
        },
      })
      countGuetRulesToggle()
    }
  }

  return (
    <>
      {state.loading ? <LoadingAbsolute formText={'Belgeleriniz yükleniyor,'} text={'Lütfen bekleyiniz...'} formLodading={true} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header
            onClick={() => {
              if (state.selectedTesis) {
                persistSelectedGarden(state.selectedTesis)
              }

              navigate('/hobiGuestProcess', {
                state: { selectedTesis: state.selectedTesis },
              })
            }}
            rules={state.selectedTesis?.id === 2}
          />
        </div>
        <div className='container'>
          <div className={`misafir-turu-content ${state.isFading ? 'fade-out' : 'fade-in'}`}>
            <InfoRedCard
              text={
                state.misafirTuru === 'gecici' ? (
                  <div>
                    Yetkilendirme işlemini <b>Bugün ({todayString})</b> tarihi için gerçekleştirmektesiniz. Misafire gönderilecek kısa mesajdaki bariyer açma/kapama işleminin gerçekleştirileceği bağlantı sadece <b>Bugün ({todayString})</b> saat <b>{kapanisSaati}</b>'a kadar geçerli olacaktır.
                  </div>
                ) : (
                  <div>Sadece 3 {/** 1 === kalıcı-misafir-hakkı */} adet kalıcı misafir ekleme hakkınız vardır.</div>
                )
              }
            />
          </div>
          <div style={{ margin: '.5rem 0 0 0', color: '#205c42' }}>Misafir Türü</div>
          <div
            style={{
              display: 'flex',
              gap: '1rem',
              margin: '0 0 .5rem 0',
              fontSize: '14px',
            }}
          >
            <GuestTypeSelector misafirTuru={state.misafirTuru} girisTipiError={state.girisTipiError} handleRadioOnCheck={handleRadioOnCheck} />
            <CheckBoxErrorText textVisible={state.girisTipiError} />
          </div>
          <div style={{ margin: '0 0 .5rem 0', color: '#205c42' }}>Misafir Bilgileri</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '0.4rem',
            }}
          >
            <GuestInfoForm state={state} handleInputChange={handleInputChange} />
            <div
              style={{
                display: 'flex',
                margin: '1rem 0 0 0',
              }}
            >
              <Button
                active
                onClick={formValidCheck}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '.8rem',
                  width: '100%',
                  border: 'none',
                  borderRadius: '25px',
                  color: '#fff',
                  backgroundColor: '#285843',
                }}
              >
                <div style={{ marginLeft: '.5rem' }}>{'Giriş İçin Yetkilendir'}</div>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Modal toggle={countGuetRulesToggle} modal={state.openGuestRulesModal} closeButton={false} body={<GuestRulesModalBody formData={state.formData} toggle={countGuetRulesToggle} dispatch={dispatch} />} setHeight={'auto'} />
      <Modal toggle={successToggle} modal={state.openSuccessModal} closeButton={false} body={<SuccessModalBody toggle={successToggle} navigate={navigate} selectedTesis={state.selectedTesis} />} setHeight={'auto'} />
    </>
  )
}

export default GuestAddFormPage
